import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Home } from "lucide-react";

const NotFound = () => {
  return (
    <div className="min-h-[100dvh] gradient-hero flex flex-col items-center justify-center px-6">
      <div className="text-center max-w-md space-y-6">
        <div className="w-20 h-20 rounded-2xl gradient-cta flex items-center justify-center mx-auto glow-primary">
          <span className="font-display text-3xl font-bold text-primary-foreground">404</span>
        </div>
        <div>
          <h1 className="font-display text-3xl font-bold mb-2">Page Not Found</h1>
          <p className="text-muted-foreground">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        <div className="flex gap-3 justify-center">
          <Button variant="outline" onClick={() => window.history.back()}>
            <ArrowLeft className="w-4 h-4 mr-1" />
            Go Back
          </Button>
          <Button variant="hero" asChild>
            <Link to="/">
              <Home className="w-4 h-4 mr-1" />
              Home
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;